import React from "react";

const SawasdeeContext = React.createContext({});

export const SawasdeeProvider = SawasdeeContext.Provider;
export const SawasdeeConsumer = SawasdeeContext.Consumer;
export default SawasdeeContext;
